import React, {useContext, useEffect} from "react";
import {View, TouchableOpacity, StyleSheet, Linking} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import {logout, logoutIcpm} from "../auth-service/auth-service";
import {styleVars} from "../../../app-style-vars";
import PtText from "../pt-text/pt-text";
import {getTranslation} from "../../../helpers/getTranslation";
import {setLogoutStart} from "../../../actions/authActions";
import UserContext from "../../../helpers/UserContext";
import {getSubdomain} from "../../../helpers/getSubdomain";
const featuresCache = () => {return require('../../../assets/countryConfigs.json')}
const getCountryFeatures = (featuresObject: any, country: string) => {
  const availableFeatures:any = [];
  Object.keys(featuresObject).forEach((featureKey) => {
    if(featuresObject[featureKey][country.toLowerCase()]) {
      availableFeatures.push(featureKey);
    }
  })
  return availableFeatures;
}
export default function Logout(props:any) {

  const logoutLabel = props.logoutLabel || getTranslation('logout.label') || 'Logout';
  const useICPM = getCountryFeatures(featuresCache(),getSubdomain()).indexOf("useICPM") >= 0;
  const dispatch = useDispatch();

  const isAuthenticated: any = useSelector((state: any) => state.authReducer.isAuthenticated);

  const logoutInProgress: any = useSelector((state:any) => state.authReducer.logoutInProgress);

  const useButtonStyle = props.useButtonStyle || false;

  const {userData, updateUserData} = useContext(UserContext);

  useEffect(() => {
    if(!isAuthenticated && !logoutInProgress) {
      console.log('****\n reseting user data after logout \n ****');
      updateUserData({
        ...userData,
        authenticated: false,
        availableCountries: [],
        language: 'en',
        dataCollected: false,
        features: [],
        availableSiteUIDs: [],
        impersonatingName: null,
        impersonatingId: null,
        impersonatingUid: null,
        canImpersonate: false,
        mustImpersonate: false,
        salesAreaDependantCustomerUid: null,
        orderRestricted: false,
        orderScenarios: [],
        resetTxtUpload: false,
        resetXlsUpload: false,
        resetCustomerUpload: false
      });
    }
  },[isAuthenticated, logoutInProgress])

  const doLogout = async() => {
    await setLogoutStart(dispatch);
    await logout(dispatch);
  }
  const doLogoutIcpm = async() => {
    await setLogoutStart(dispatch);
    await logoutIcpm(dispatch)
  }
  const buttonStyle = useButtonStyle ? styles.logoutButtonContainer : null;
  const buttonTextStyle = useButtonStyle ? styles.logoutButtonText : styles.footerLinkText;
  const disabledButtonStyle = useButtonStyle ? [styles.logoutButtonContainer, styles.logoutButtonDisabled] : null;
  const disabledTextStyle = useButtonStyle ? [styles.logoutButtonText, {color: styleVars.boschDarkGray}] : [styles.footerLinkText, {color: styleVars.boschLightGray}];

  return (
    <>
      {useICPM ?
          <View style={useButtonStyle ? null : styles.footerLinkContainer}>
            {isAuthenticated && !logoutInProgress ?
                <TouchableOpacity onPress={doLogoutIcpm} style={buttonStyle}>
                  <PtText style={buttonTextStyle}>
                    {logoutLabel}
                  </PtText>
                </TouchableOpacity>
                :
                <View style={disabledButtonStyle}>
                  <PtText style={disabledTextStyle}>
                    {logoutLabel}
                  </PtText>
                </View>
            }
          </View>
      :
          <View style={useButtonStyle ? null : styles.footerLinkContainer}>
        {isAuthenticated && !logoutInProgress ?
          <TouchableOpacity onPress={doLogout} style={buttonStyle}>
            <PtText style={buttonTextStyle}>
              Logout ICPM
            </PtText>
          </TouchableOpacity>
          :
          <View style={disabledButtonStyle}>
            <PtText style={disabledTextStyle}>
              {logoutLabel}
            </PtText>
          </View>
        }
      </View>
      }
    </>
  )

}


const styles = StyleSheet.create({
  footerLinkContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginBottom: styleVars.rem(.5),
  },
  footerLinkText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
  logoutButtonContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginVertical: styleVars.rem(.5),
    marginHorizontal: styleVars.rem(.5),
    backgroundColor: styleVars.boschDarkBlue,
    justifyContent: 'center',
    alignItems: 'center'
  },
  logoutButtonDisabled: {
    backgroundColor: styleVars.boschLightGray,
  },
  logoutButtonText: {
    fontSize: styleVars.rem(.875),
    color: '#fff',
  },

});
